/* eslint-disable no-console, no-trailing-spaces, comma-dangle, no-else-return */
import Axios, { almacenAxios } from '@/services/Axios';
import { TokenUtils } from '@/utils/TokenUtils';
import { PurchaseOrderRequest } from '../models/PurchaseOrder/PurchaseOrderRequest';
import { CashCloseData } from '../models/PurchaseOrder/CashCloseData';
import { PurchaseOrderSingleItem } from '../models/PurchaseOrderSingleItem';
import { SavedQuotationData } from '../models/SavedQuotationData';

const resource = '/purchase-order';
const resourceV2 = '/v1/sale';

export default {
  async createPurchaseOrder(employeeId, clientId, clientDiscount, total) {
    const payload = new PurchaseOrderRequest(employeeId, clientId,
      clientDiscount, total, 1);
    let response = null;
    try {
      response = await Axios.post(resource, payload);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'asdasd' };
    }
    return response;
  },

  async createPurchaseOrderPayment(purchaseOrderId, amount, paymentMethod) {
    const payload = { purchaseOrderId, amount, paymentMethod };
    let response = null;
    try {
      response = await Axios.post(`${resource}/payment`, payload);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'asdasd' };
    }
    return response;
  },

  async finishPurchaseOrder(employeeId, clientId, clientDiscount, total,
    payments, products, productsTotal, ignoreInventory) {
    const payload = {
      employeeId,
      clientId,
      clientDiscount,
      total,
      type: 1,
      payments,
      products,
      productsTotal,
      ignoreInventory,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };
    
    try {
      const response = await Axios.post(`${resource}/finish-order`, payload, { headers });
      return response;
    } catch (error) {
      console.error('Error en finishPurchaseOrder:', error);
      
      if (error.response) {
        return { 
          error: true,
          message: error.response.data.message || 'Error en el servidor',
          status: error.response.status
        };
      } else if (error.request) {
        return { 
          error: true,
          message: 'No se recibió respuesta del servidor'
        };
      } else {
        return { 
          error: true,
          message: error.message || 'Error al configurar la solicitud'
        };
      }
    }
  },

  async finishPurchaseOrderV2(
    storeId, employeeId, clientId, clientDiscount, total,
    payments, products, productsTotal, delivery
  ) {
    const payload = {
      storeId,
      employeeId,
      clientId,
      clientDiscount,
      total,
      type: 1,
      payments,
      products,
      productsTotal,
      delivery,
    };

    try {
      const response = await almacenAxios.post(`${resourceV2}/finish-order`, payload);
      return response.data;
    } catch (error) {
      console.error('Error en finishPurchaseOrderV2:', error);
      throw new Error('Error al finalizar la orden de compra. Por favor, inténtelo de nuevo.');
    }
  },

  async finishSavedPurchaseOrder(id) {
    const payload = {
      id,
    };
    let response = null;
    try {
      response = await Axios.put('quotation-order/finish-order', payload);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'asdasd' };
    }
    return response;
  },

  async getCashCloseData(storeId, filters = {}) {
    const params = {
      storeId,
      ...filters,
    };

    let data = await Axios.get('cash-close/data', { params });
    data = data.data;

    const response = new CashCloseData(
      data.ordersTotalAmount,
      data.paymentsTotalAmount,
      data.cashAmount,
      data.debitCardAmount,
      data.creditCardAmount,
      data.checkAmount,
      data.transferAmount,
      data.orders,
      data.currentCashStart,
      data.invoiceSummary,
    );

    return response;
  },

  async CashClose(amount, storeId) {
    let response = null;
    try {
      const payload = { amount, storeId };
      response = await Axios.put('cash-close', payload);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'Error al generar el cierre de caja' };
    }
    return response;
  },

  async getPurchaseOrderData(id) {
    let response = null;
    let data = await Axios.get(`${resource}/${id}`);
    data = data.data;
    response = new PurchaseOrderSingleItem(data.id, data.employee, data.client, data.total,
      data.type, data.createdDt, data.isClosed, data.cashPayments, data.debitCardPayments,
      data.creditCardPayments, data.checkPayments,
      data.transferPayments, data.products);
    return response;
  },

  async getPurchaseOrderDataFromFolio(folio) {
    let response = null;
    let data = await Axios.get(`${resource}/get-data-from-folio?folio=${folio}`);
    data = data.data;
    response = new PurchaseOrderSingleItem(data.id, data.employee, data.client, data.total,
      data.type, data.createdDt, data.isClosed, data.cashPayments, data.debitCardPayments,
      data.creditCardPayments, data.checkPayments,
      data.transferPayments, data.products);
    return response;
  },

  async saveQuotation(clientId, clientDiscount, total, products) {
    let response = null;
    const payload = {
      clientId,
      clientDiscount,
      total,
      products,
    };
    const headers = {
      Authorization: `Bearer ${TokenUtils.getToken()}`,
    };

    try {
      response = await Axios.post('quotation-order', payload, { headers });
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'asdasd' };
    }
    return response;
  },

  async getSavedQuotationsAutocompleteData(clientId = null, storeId = null) {
    let data = await Axios.get('quotation-order/autocomplete', {
      params: {
        clientId,
        storeId,
      },
    });
    data = data.data;
    return data;
  },

  async getSavedQuotationData(savedQuotationId, storeId) {
    let data = await Axios.get(`quotation-order/${savedQuotationId}`);
    data = data.data;
    const savedQuotationData = new SavedQuotationData(data.id, data.total,
      data.clientId, data.products, storeId);
    return savedQuotationData;
  },

  async deletePurchaseOrder(purchaseOrderId) {
    let response = null;
    try {
      response = await Axios.delete(`purchase-order/${purchaseOrderId}`);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'No se pudo eliminar la venta, favor de contactar con un administrador' };
    }
    return response;
  },

  async sendEmail(saleId, saleFolio, email) {
    let response = null;
    const payload = {
      sale_id: saleId,
      sale_folio: saleFolio,
      recipient_email: email,
    };

    try {
      response = await almacenAxios.post('/v1/email/send-sale-documents', payload);
    } catch (e) {
      console.error(e);
      response = e;
      return { error: 'No se pudo enviar el correo, favor de contactar con un administrador' };
    }
    return response;
  }
};
